<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>运营管理</el-breadcrumb-item>
            <el-breadcrumb-item>留言管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-input placeholder="请输入用户名/留言内容" clearable v-model="queryInfo.query" @clear="getList()" style="width: 300px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-select v-model="queryInfo.query1"  placeholder="请选择门店" @change="getList()"  style="margin-left:10px" clearable  filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="queryInfo.status" placeholder="请选择回复状态" @change="getList()" style="margin-left:10px" clearable>
                        <el-option label="已回复" value="1"></el-option>
                        <el-option label="未回复" value="0"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--商品列表区域-->
            <el-table :data="list" :key="list.index" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="ID" type="index"  width="50"></el-table-column>
                <el-table-column label="用户" prop="username"  width="150"></el-table-column>
                <el-table-column label="门店" prop="storename"  width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="留言内容" prop="content"  width="400" show-overflow-tooltip></el-table-column>
                <el-table-column label="回复信息" prop="recontent"  width="400">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.recontent" :content="scope.row.recontent" placement="top" :disabled="!scope.row.recontent || scope.row.recontent.length <= 50">
                            <span>{{ getFirstReply(scope.row.recontent) }}</span>
                        </el-tooltip>
                        <span v-else style="color: #ccc;">暂无回复</span>
                    </template>
                </el-table-column>
                <el-table-column label="回复状态" prop="adddate"  width="120">
                    <template slot-scope="scope">
                        <!-- {{ scope.row }} -->
                        <el-tooltip class="item" effect="dark" :content="'回复：'+scope.row.recontent+'（'+scope.row.redate+' ）'" placement="top" v-if="scope.row.status" >
                            <el-tag  type="success">已回复</el-tag>
                        </el-tooltip>
                       <el-tag v-else type="info">未回复</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="发布日期" prop="adddate"  width="200"></el-table-column>
                <el-table-column label="操作" width="180">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                            <el-button type="primary" icon="el-icon-edit" size="mini" @click="openReplyDialog(scope.row)" v-permission="'btn:operations:message:reply'">回复</el-button>
                            <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)" v-permission="'btn:operations:message:delete'"></el-button>
                    </template>
                </el-table-column>
                </el-table>
            <!--商品列表区域-->
             <!--分页区域-->
             <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
        </el-card>
        
        <!-- 回复弹窗 -->
        <el-dialog title="回复留言" :visible.sync="replyDialogVisible" width="60%">
            <el-form :model="replyForm" label-width="100px">
                <el-form-item label="用户">
                    <el-input v-model="replyForm.username" readonly></el-input>
                </el-form-item>
                <el-form-item label="留言内容">
                    <el-input type="textarea" v-model="replyForm.content" readonly :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="历史回复" v-if="replyForm.recontent">
                    <el-input type="textarea" v-model="replyForm.recontent" readonly :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="新回复内容">
                    <el-input type="textarea" v-model="replyForm.newReply" placeholder="请输入回复内容..." :rows="4"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="replyDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitReply" :loading="btnLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return{
            queryInfo: {
                query: '',
                query1:'',
                status: '',
                pagenum: 1,
                pagesize: 20
            },
            total:0,
            list: [],
            storelist:[],
            admin_token:'',
            // 回复相关
            replyDialogVisible: false,
            btnLoading: false,
            replyForm: {
                id: null,
                username: '',
                content: '',
                recontent: '',
                newReply: ''
            }
        }
        
    },
    created() {
         this.getList()
         this.GetStore()
         this.admin_token = window.sessionStorage.getItem('admin_token') 
    },
    
    methods:{
        async GetStore(){
            const { data: res } = await this.$http.get('store/')
            if(res.status == 0){
                this.storelist = res.data
            }
       },
        async getList() {
            const { data:res } = await this.$http.get('messagelist/',{ params: this.queryInfo })
            if(res.status == 1){
                this.total = res.data.totalCount;
                this.list = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
            }
            for (let index = 0; index < res.data.list.length; index++) {
                this.list[index].id= res.data.list[index].pk;
            }
        },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getList()
       },
       async DelInfo(id){
            const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm'){
                    return this.$message.info('已取消删除！')
                }
                const { data: res } = await this.$http.get('messagedel/'+ id,{ params: {admin_token:this.admin_token} })
            
                if (res.status === 0) { 
                    this.$message({message: '删除成功！',type: 'success'})
                }
                this.getList()
        },
        
        // 打开回复弹窗
        openReplyDialog(row) {
            this.replyForm.id = row.id
            this.replyForm.username = row.username
            this.replyForm.content = row.content
            this.replyForm.recontent = row.recontent || ''
            this.replyForm.newReply = ''
            this.replyDialogVisible = true
        },
        
        // 提交回复
        async submitReply() {
            if (!this.replyForm.newReply.trim()) {
                this.$message.error('请输入回复内容')
                return
            }
            
            this.btnLoading = true
            
            try {
                // 构建新的回复内容，追加到原有回复后面
                const now = new Date()
                const pad = n => String(n).padStart(2, '0')
                const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
                let updatedRecontent = ''
                if (this.replyForm.recontent) {
                    updatedRecontent = this.replyForm.recontent + '\n\n--- ' + dateStr + ' ---\n' + this.replyForm.newReply
                } else {
                    updatedRecontent = '--- ' + dateStr + ' ---\n' + this.replyForm.newReply
                }
                
                const { data: res } = await this.$http.post('messagereply/', {
                    id: this.replyForm.id,
                    recontent: updatedRecontent,
                    admin_token: this.admin_token
                })
                
                if (res.status === 0) {
                    this.$message.success('回复成功')
                    this.replyDialogVisible = false
                    this.getList() // 刷新列表
                } else {
                    this.$message.error(res.message || '回复失败')
                }
            } catch (error) {
                this.$message.error('请求失败，请稍后重试')
            } finally {
                this.btnLoading = false
            }
        },
        
        // 获取第一条回复内容，超过50个字符显示省略号
        getFirstReply(recontent) {
            if (!recontent) return ''
            
            // 提取第一条回复（去掉时间戳分隔符）
            const lines = recontent.split('\n')
            let firstReply = ''
            
            for (let line of lines) {
                // 跳过时间戳行（以 --- 开头和结尾的行）
                if (!line.trim().startsWith('---') || !line.trim().endsWith('---')) {
                    if (line.trim() && !firstReply) {
                        firstReply = line.trim()
                        break
                    }
                }
            }
            
            // 如果没找到有效回复，返回原内容的前50个字符
            if (!firstReply) {
                firstReply = recontent.trim()
            }
            
            // 限制显示长度
            if (firstReply.length > 50) {
                return firstReply.substring(0, 50) + '...'
            }
            
            return firstReply
        }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
        height: 0px;
    }

</style>